import styled, { css } from 'styled-components';

export const ContentHubStyle1 = styled.div`
  text-align: center;
  background-color: #fff;

  & > div {
    padding-bottom: 24px;
  }

  & *[data-id='content-hub-card-content'] {
    display: flex;
    flex-direction: column;
    place-items: center;
  }

  & img {
    min-height: 613px;
    min-width: 100%;
    object-fit: cover;
  }

  @media (${(props) => props.theme.header.mobileSwitch}) {
    text-align: left;
    & *[data-id='content-hub-card-content'] {
      place-items: baseline;
    }
    & img {
      min-height: auto;
    }
  }
`;

export const ContentHubStyle2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;

  & > div {
    background-color: #fff;
  }

  & img {
    min-height: 419px;
    min-width: 100%;
    object-fit: cover;
  }

  @media (${(props) => props.theme.header.mobileSwitch}) {
    grid-template-columns: none;
    & img {
      min-height: auto;
    }
  }
`;

export const ContentHubStyle3 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 25px;

  & *[data-id='content-hub-card-headline'] {
    font-size: 18px;
    margin: 0;
    line-height: 25px;
    padding-top: 12px;
  }

  & > div {
    background-color: #fff;
  }

  & img {
    min-height: 274px;
    min-width: 100%;
    object-fit: cover;
  }

  @media (${(props) => props.theme.header.mobileSwitch}) {
    grid-template-columns: none;
    & img {
      min-height: auto;
    }
  }
`;

export const ContentHubStyle5 = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  gap: 25px;

  & > div > div {
    background-color: #fff;
    height: fit-content;
  }

  & img {
    min-height: 422px;
    min-width: 100%;
    object-fit: cover;
  }

  @media (${(props) => props.theme.header.mobileSwitch}) {
    grid-template-columns: none;
    & img {
      min-height: auto;
    }
  }
`;

export const ContentHubStyle5Main = styled.div`
  height: 452px;

  & img {
    min-height: 418px;
    min-width: 100%;
    object-fit: cover;
  }
  @media (${(props) => props.theme.header.mobileSwitch}) {
    height: auto;
    order: -1;

    & img {
      min-height: auto;
    }
  }
`;

export const ContentHubStyle5Rows = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 25px;

  & *[data-id='content-hub-card-headline'] {
    font-size: 18px;
    margin: 0;
    line-height: 25px;
    padding-top: 12px;
  }

  & > div {
    height: 452px;
  }

  & img {
    min-height: 154px;
    max-height: 154px;
    min-width: 100%;
    object-fit: cover;
  }

  @media (${(props) => props.theme.header.mobileSwitch}) {
    grid-template-rows: none;
    & > div {
      height: auto;
    }
    & img {
      min-height: auto;
      max-height: 140px;
      height: 100%;
    }

    & *[data-id='content-hub-card'] {
      display: grid;
      grid-template-columns: 4fr 8fr;
      min-height: 140px;
    }

    & *[data-id='content-hub-card-description'] {
      display: none;
    }

    & *[data-id='content-hub-card-content'] {
      padding: 0 0 0 15px;
      display: flex;
      flex-direction: column;
      place-content: center;
    }

    & *[data-id='content-hub-card-headline'] {
      margin: 0;
    }

    & *[data-id='content-hub-card-colorline'] {
      margin: 5px 0px;
    }
  }
`;

export const ContentHubDynamicContent = styled.div`
  & > div[data-module-name='CONTAINER_LARGE_B']:first-child {
    padding-top: 30px !important;
  }

  div[data-module-name='CONTAINER_LARGE_B']
    + div[data-module-name='CONTAINER_LARGE_B'] {
    padding-top: 30px;
    background: white;
    @media (${(props) => props.theme.header.mobileSwitch}) {
      padding-top: 0px;
    }
  }

  *[data-module-name='CONTENT_HUB_HERO'] > div {
    padding-top: 30px !important;

    @media (max-width: 1199px) {
      padding-left: 12.5px;
      padding-right: 12.5px;
      max-width: 960px;
    }

    @media (min-width: 1200px) {
      margin: -12.5px;
      width: calc(100% + 25px);
    }
  }

  ${({ showMore, isMobile }) =>
    showMore
      ? css`
          height: 100%;
        `
      : css`
          height: ${isMobile ? '550px' : '900px'};
          -webkit-mask-image: -webkit-gradient(
            linear,
            left top,
            left bottom,
            from(rgba(0, 0, 0, 1)),
            to(rgba(0, 0, 0, 0))
          );
          overflow: hidden;
        `};
`;

export const ContentHubDynamicShowMore = styled.span`
  color: ${(props) => props.theme.color.primary800};
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    color: ${(props) => props.theme.color.primary800};
    transform: rotate(90deg);
    width: 16px;
    height: 16px;
    margin-right: 15px;
  }
`;
